import { s16, s24, s32, s8 } from '@ardoq/design-tokens';
import { text2, header4, header1, text1 } from '@ardoq/typography';
import styled, { css } from 'styled-components';
import { DoqLayout } from './types';

export const DoqContainer = styled.div<{ $layout?: DoqLayout }>`
  display: flex;
  ${({ $layout }) => getContainerStyle($layout)};
`;

const getContainerStyle = (layout: DoqLayout = DoqLayout.PAGE) => {
  switch (layout) {
    case DoqLayout.DIALOG:
      return css`
        width: 401px;
        padding: ${s16};
        flex-direction: row;
        /* the face component */
        & > svg {
          margin-top: ${s8};
        }
      `;
    case DoqLayout.VERTICAL:
      return css`
        width: 528px;
        padding: ${s24};
        flex-direction: column;
        align-items: center;
        position: relative;
        & > svg {
          margin-top: 41px;
        }
      `;
    case DoqLayout.PAGE:
      return css`
        width: 880px;
        padding: ${s24};
        flex-direction: row;
        /* the face component */
        & > svg {
          margin-top: ${s24};
        }
      `;
  }
};

export const Content = styled.div<{ $layout?: DoqLayout }>`
  ${({ $layout }) => getContentStyle($layout)};
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const getContentStyle = (layout: DoqLayout = DoqLayout.PAGE) => {
  switch (layout) {
    case DoqLayout.DIALOG:
      return css`
        padding-top: 36px;
        position: relative;
      `;
    case DoqLayout.VERTICAL:
      return css`
        width: 100%;
        align-items: center;
      `;
    case DoqLayout.PAGE:
      return css`
        padding-top: 80px;
        position: relative;
      `;
  }
};

export const Body = styled.div<{ $layout?: DoqLayout }>`
  ${({ $layout }) => getBodyStyle($layout)};
  flex: 1;
  white-space: pre-line;
`;

const getBodyStyle = (layout: DoqLayout = DoqLayout.PAGE) => {
  switch (layout) {
    case DoqLayout.DIALOG:
      return css`
        ${text2};
        padding-top: ${s16};
        padding-left: ${s8};
      `;
    case DoqLayout.VERTICAL:
      return css`
        ${text1};
        padding-top: ${s32};
      `;
    case DoqLayout.PAGE:
      return css`
        ${text1};
        padding-top: ${s32};
        padding-left: ${s32};
      `;
  }
};

export const Footer = styled.div<{ $layout?: DoqLayout }>`
  ${({ $layout }) => getFooterStyle($layout)}
`;

const getFooterStyle = (layout: DoqLayout = DoqLayout.PAGE) => {
  switch (layout) {
    case DoqLayout.DIALOG:
      return css`
        align-self: flex-end;
      `;
    case DoqLayout.VERTICAL:
      return css`
        padding-top: ${s16};
        align-self: center;
      `;
    case DoqLayout.PAGE:
      return css`
        align-self: flex-end;
      `;
  }
};

export const SpeechBubbleContainer = styled.div<{ $layout?: DoqLayout }>`
  ${({ $layout }) => getSpeechBubbleContainerStyle($layout)}
`;

const getSpeechBubbleContainerStyle = (layout: DoqLayout = DoqLayout.PAGE) => {
  switch (layout) {
    case DoqLayout.DIALOG:
      return css`
        position: absolute;
        width: max-content;
        top: 0;
        right: 0;
      `;
    case DoqLayout.VERTICAL:
      return css`
        position: absolute;
        top: ${s24};
      `;
    case DoqLayout.PAGE:
      return css`
        position: absolute;
        width: max-content;
        top: 0;
        right: 0;
      `;
  }
};

function getSpeechBubbleTextStyle(layout: DoqLayout = DoqLayout.PAGE) {
  switch (layout) {
    case DoqLayout.DIALOG:
      return css`
        ${header4};
        height: 36px;
      `;
    case DoqLayout.VERTICAL:
      return css`
        ${header1};
        font-size: 28px;
        height: 80px;
      `;
    case DoqLayout.PAGE:
      return css`
        ${header1};
        height: 80px;
        font-size: 28px;
      `;
  }
}

export const SpeechBubbleText = styled.span<{ $layout?: DoqLayout }>`
  ${({ $layout }) => getSpeechBubbleTextStyle($layout)}
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
`;
